import { render, staticRenderFns } from "./CreateAssignment.vue?vue&type=template&id=556c9a6e"
import script from "../../services/assignment/create-assignment.js?vue&type=script&lang=js&external"
export * from "../../services/assignment/create-assignment.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/assignment/create-assignment.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports